module.exports = __webpack_public_path__ + "img/Delete-icon.2cfcdbcb.svg";